import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ClientCarousel.css'

/*const settings = {
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 3,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    arrows: false
}; */

const clientLogos = [
    "https://logodix.com/logo/269808.png",
    "https://www.dic-global.com/common/images/ogp.png",
    "https://images.livemint.com/img/2020/05/27/1600x900/npci-kRnG--621x414@LiveMint_1590553136461.jpg",
    "https://getlogovector.com/wp-content/uploads/2020/02/umicore-logo-vector.png",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9nFue3YNFmxaiBwlzFAIH8UVBt74ZPuh-p0TOmRwQkofJqFcErBh048BxSQEsY6ReT6Y&usqp=CAU",
    "https://scontent.fbom3-2.fna.fbcdn.net/v/t1.18169-9/14463250_1121273641287800_6176877044527607560_n.png?_nc_cat=105&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=NeHrK9LdujMAX9Zeh3c&_nc_ht=scontent.fbom3-2.fna&oh=00_AT_WqeMD6-PjjqXRgXcaPunsoCCYajIaKJBbJK1n2CjMRw&oe=621624C1"
]

function ClientsCarousel() {
  return (
//     <div className='slider-container'>
//         <h2>OUR CLIENTS</h2>
//         <Slider {...settings} className='slider'>
//             {
//                 clientLogos.map(src => {
//                     return (
//                         <div>
//                             <img src={src} className='client-logo'/>
//                         </div>
//                     )
//                 })
//             }
//     </Slider>
//   </div>

    <div className='clients'>
        <h2 className='our-clients-heading'>OUR CLIENTS</h2>

        <div className='clients-grid'>
            {/* <div className='clients-grid-item'>hello</div>
            <div className='clients-grid-item'>hello</div>
            <div className='clients-grid-item'>hello</div>
            <div className='clients-grid-item'>hello</div>
            <div className='clients-grid-item'>hello</div>
            <div className='clients-grid-item'>hello</div> */}
        

        {
            clientLogos.map(item => {
                return (
                    <div className='clients-grid-item'>
                        <img src={item} className='client-logo' alt='client logo' />
                    </div>
                )
            })
        }
        </div>
    </div>
  );
}

export default ClientsCarousel;
